// extracted by mini-css-extract-plugin
export default {"modCarpet":"FlooringMenu_modCarpet__lifQ4","mainMenu":"FlooringMenu_mainMenu__AJlWK","activeMenuTab":"FlooringMenu_activeMenuTab__xkOhj"};